import styled from 'styled-components'

import { ColumnFlex } from 'components/common/genericStyles'

export const Container = styled.div`
    ${ColumnFlex}
    justify-content: space-evenly;

    min-width: 328px;
    min-height: 100px;
    height: max-content;

    margin: 5px;
    padding: 20px;

    background: #36383c;

    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08),
        0px 4px 12px -4px rgba(0, 0, 0, 0.08);
    border-radius: 8px;

    position: absolute;
    top: 100%;
    bottom: 0;
    right: 0;
    transform: translateX(20%);

    .divider {
        margin: 10px 0px;
    }
`

export const Button = styled.button`
    outline: none;
    border: none;
    background: none;
    cursor: pointer;
    margin-top: 20px;

    :hover {
        opacity: 0.5;
    }
`
